import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import ContactType from "../../../../Utility/Crud/ContactType";
import MainContext from "../../../../Context/MainContext/MainContext";

export default withRouter(
  class CardAdminContactTypeList extends CardClass {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders the content of the card.
     */
    renderContent() {
      return (
        <Table
          search={true}
          columns={[
            { key: "id", name: "ID", type: "number" },
            { key: "name", name: "Name", type: "string" },
          ]}
          rows={ContactType.sort(
            Object.values(this.context.contactTypesIndexed),
          )}
          onClick={(contactType) => {
            this.props.history.push({
              pathname: "/admin/contactType/" + contactType.id,
            });
          }}
        />
      );
    }
  },
);
